export const formatCurrency = (amountInCents: number) => {
  const amountInDollars = amountInCents / 100
  return new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
  }).format(amountInDollars)
}
